/* eslint-disable @typescript-eslint/no-var-requires */
import React, { FunctionComponent, MutableRefObject, useRef } from 'react';

import './animation043.less';

interface IAnimation043Item {
  icon: string;
  time: string;
  title: string;
  color: string;
  list: [];
}

interface IAnimation043Props {
  items: IAnimation043Item[];
  onCompleted: () => void;
}

const Animation043: FunctionComponent<IAnimation043Props> = ({
  items,
  onCompleted,
}) => {
  const crrRef = useRef() as MutableRefObject<HTMLDivElement>;
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;

  return (
    <div className="animation043-content">
      <div ref={crrRef} className="animation043 component">
        {items.map((itm: IAnimation043Item, idx: number) => (
          <div
            key={idx}
            className={`animation043-item animation043-item-${idx}`}
          >
            <>
              <div className="animation043-head">
                <div
                  className="animation043-time"
                  style={{
                    color: `${itm.color}`,
                  }}
                  dangerouslySetInnerHTML={{ __html: itm.time }}
                />
                <div
                  className="animation043-title"
                  style={{
                    background: `url('${getImg(itm.icon)}') no-repeat`,
                    backgroundPosition: 'center',
                  }}
                  dangerouslySetInnerHTML={{ __html: itm.title }}
                />
                {(idx === 0 || idx === 3) && (
                  <div className="animation043-hide-block" />
                )}
              </div>
            </>
            <div className="animation043-list">
              <div
                className="animation043-line"
                style={{
                  backgroundColor: `${itm.color}`,
                }}
              />
              <ul>
                {itm.list.map((itms: string, idxs: number) => (
                  <li key={idxs}>{itms}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation043;
